<div class="holder">
  <div class="title-holder">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar usuário</mat-label>
      <input matInput [(ngModel)]="searchValue" placeholder="Nome ou email">
    </mat-form-field>
  </div>
  <app-admin-users-table [users]="users()" [searchValue]="searchValue"></app-admin-users-table>
</div>
